import { useEffect, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { adminPortalLogin } from "../features/urlConst/domainUrl";
// redux
import { useDispatch, useSelector } from "react-redux";
import {
  resetAuth,
  setToken,
  getDistributionStatus,
  getOrderStatus,
  fetchProfile,
  setUserInfo,
} from "../features/auth/authSlice";
import { resetOrder, resetSearchSort } from "../features/order/orderSlice";
import { resetSetting } from "../features/setting/settingSlice";
import { persistor } from "../app/store";
import { resetUsers } from "../features/user/userSlice";
import { resetProfile } from "../features/profile/profileSlice";
// import { toast } from 'react-toastify'

export const useAuthStatus = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(true);
  const [tokenParams, setTokenParams] = useState("");
  const [checkingParamStatus, setCheckingParamStatus] = useState(true);
  const [checkingProfile, setCheckingProfile] = useState(false);

  const { token } = useSelector((state) => state.auth);
  const {
    distribution_status,
    order,
    order_detail,
    order_status,
    destinations,
    order_media,
    orderError,
  } = useSelector((state) => state.order);
  const { holiday, brands, prefectures, exceptionalHoliday, settingError } =
    useSelector((state) => state.setting);
  const { users, userError } = useSelector((state) => state.user);
  const { profileError } = useSelector((state) => state.profile);

  const navigateToLoginPortal = () => {
    window.location.href = adminPortalLogin;
  };

  const dispatch = useDispatch();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  function useQuery() {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
  }
  const query = useQuery();

  function getTokenParams() {
    const tokenUrl = query.get("token");
    if (tokenUrl) {
      console.log("ini tokeen")
      console.log("tokenParams :", tokenUrl, "token")
      setTokenParams(tokenUrl);
    } else if(!token) {
      setCheckingStatus(false);
      navigateToLoginPortal()
      setTokenParams(null)
    }
    setCheckingParamStatus(false)
  }

  async function checkToken(token) {
    const response = await dispatch(fetchProfile(token));
    if (response?.payload?.data?.result !== "success") {
      setCheckingStatus(false);
      setTokenParams(null)
      setLoggedIn(false)
      return;
    }
    dispatch(setUserInfo(response.payload.data.value));
    dispatch(getDistributionStatus(token));
    dispatch(getOrderStatus(token));
    setCheckingProfile(true)
    setCheckingStatus(false);
  }

  useEffect(() => {
    getTokenParams();
  });

  useEffect(() => {
    if(tokenParams) {
      dispatch(setToken(tokenParams));
    }
  }, [tokenParams]);

  useEffect(() => {
    if (token && !checkingProfile && tokenParams) {
      checkToken(token);
    }
  }, [token]);

  useEffect(() => {
    if (
      token &&
      orderError?.description !== "expired token" &&
      profileError?.description !== "expired token" &&
      userError?.description !== "expired token" &&
      settingError?.description !== "expired token" &&
      //
      distribution_status?.error_message !== "token_expired" &&
      distribution_status?.error_message !== "wrong_token" &&
      order?.error_message !== "token_expired" &&
      order?.error_message !== "wrong_token" &&
      order_detail?.error_message !== "token_expired" &&
      order_detail?.error_message !== "wrong_token" &&
      holiday?.error_message !== "token_expired" &&
      holiday?.error_message !== "wrong_token" &&
      exceptionalHoliday?.error_message !== "token_expired" &&
      exceptionalHoliday?.error_message !== "wrong_token" &&
      brands?.error_message !== "token_expired" &&
      brands?.error_message !== "wrong_token" &&
      prefectures?.error_message !== "token_expired" &&
      prefectures?.error_message !== "wrong_token" &&
      destinations?.error_message !== "token_expired" &&
      destinations?.error_message !== "wrong_token" &&
      order_status?.error_message !== "token_expired" &&
      order_status?.error_message !== "wrong_token" &&
      order_media?.error_message !== "token_expired" &&
      order_media?.error_message !== "wrong_token" &&
      users?.error_message !== "token_expired" &&
      users?.error_message !== "wrong_token"
    ) {
      setLoggedIn(true);
      setCheckingStatus(false);
    } else {
      if(!checkingParamStatus) {
      dispatch(resetSearchSort());
      dispatch(resetOrder());
      dispatch(resetUsers());
      dispatch(resetProfile());
      dispatch(resetSetting());
      dispatch(resetAuth());
      // remove persisted data from local storage
      persistor.purge();
      setLoggedIn(false);
        setCheckingStatus(false);
      }
      // toast.error('Login session expired')
    }
  }, [
    token,
    distribution_status,
    order,
    order_detail,
    holiday,

    exceptionalHoliday,
    brands,
    prefectures,

    destinations,
    order_status,
    order_media,
    users,

    userError,
    orderError,
    profileError,
    settingError,
    dispatch,
  ]);

  return { loggedIn, checkingStatus };
};
